import { QuestionViewModel } from './questionview.model';

export class SectionViewModel {
    public sectionId: number;
    public sectionName: string;
    public sequenceNumber: number;
    public sectionDescription: string;
    public sectionToolTip: string;
    public gridQuestions:GridViewModel[];
    public questions: QuestionViewModel[];
    public parentQuesResponse: string;
    public parentSectionId:number;
    public parentQuestionGuid:string;
    public ParentSectionGuid:string;
    public SectionGuid:string;
    public hasValidation: boolean;
      
    //
    totalQuestionVisible:number;
    //Wf related properties

    public IsReadOnly:boolean=false;
    public IsAccessiibleInWFStep:boolean=true;

    public isSectionSelected :boolean = false;
    public sectionDotColor :string ="";
    public sectionLookUpEntityId : string = "";
isSecParentQuestionVisible: any;

}

export class GridViewModel{

   public gridId: number;
   public sequenceNumber: number;
   public response:ResponseModel[];
}

export class ResponseModel
{
    public isDefaultControl:boolean=true;
    public sequenceNumber: number;
    public questions: QuestionViewModel[];
    public surveyResponseRelId? :number;
}